import { IconProps } from "typing";
import { theme } from "../themes";

export const MySecurityIcon = ({
  width = "20",
  height = "20",
  color = theme.colors.neutral["999"],
  testId = "my-security-icon",
}: IconProps) => {
  return (
    <svg
      width={width}
      data-testid={testId}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.166 17.5H5.83268C4.91185 17.5 4.16602 16.7542 4.16602 15.8333V9.16667C4.16602 8.24583 4.91185 7.5 5.83268 7.5H14.166C15.0868 7.5 15.8327 8.24583 15.8327 9.16667V15.8333C15.8327 16.7542 15.0868 17.5 14.166 17.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.9987 14.2413V12.083"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4419 11.0161C10.686 11.2601 10.686 11.6559 10.4419 11.8999C10.1979 12.144 9.80214 12.144 9.55806 11.8999C9.31398 11.6559 9.31398 11.2601 9.55806 11.0161C9.80214 10.772 10.1979 10.772 10.4419 11.0161"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66602 7.5V5.83333V5.83333C6.66602 3.9925 8.15852 2.5 9.99935 2.5V2.5C11.8402 2.5 13.3327 3.9925 13.3327 5.83333V5.83333V7.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
